(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2720],{

/***/ 31549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var app_hooks_lang__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91289);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var useMetaDescription = function useMetaDescription() {
  var t = (0,app_hooks_lang__WEBPACK_IMPORTED_MODULE_1__/* .useTranslate */ .q)();
  return function (text) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
      name: "description",
      content: text || t("meta.description")
    });
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useMetaDescription);

/***/ }),

/***/ 84563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4730);
/* harmony import */ var app_components_auth_auth_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35052);
/* harmony import */ var app_context_player_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48346);
/* harmony import */ var app_hooks_go_back_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71014);
/* harmony import */ var app_hooks_lang__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(91289);
/* harmony import */ var app_store_slices_user__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38886);
/* harmony import */ var app_store_store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4062);
/* harmony import */ var app_utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31549);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67294);
/* harmony import */ var _log_in_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(45550);
/* harmony import */ var _log_in_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_log_in_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);


var _excluded = ["openplayer", "redirect"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var LogIn = function LogIn() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();

  var _router$query = router.query,
      openplayer = _router$query.openplayer,
      redirect = _router$query.redirect,
      rest = (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_router$query, _excluded);

  var _useAppSelector = (0,app_store_store__WEBPACK_IMPORTED_MODULE_5__/* .useAppSelector */ .CG)(app_store_slices_user__WEBPACK_IMPORTED_MODULE_4__/* .selectUserState */ .tH),
      session = _useAppSelector.session;

  var _usePlayerContext = (0,app_context_player_context__WEBPACK_IMPORTED_MODULE_2__/* .usePlayerContext */ .gD)(),
      setFullscreenPlayerInitialyOpen = _usePlayerContext.setFullscreenPlayerInitialyOpen;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false),
      queryParamsProcessed = _useState[0],
      setQueryParamsProcessed = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false),
      openPlayerAfterLogin = _useState2[0],
      setOpenPlayerAfterLogin = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(null),
      redirectTo = _useState3[0],
      setRedirectTo = _useState3[1];

  (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(function () {
    if (router.isReady) {
      if (openplayer) {
        setOpenPlayerAfterLogin(true);
      }

      if (redirect) {
        setRedirectTo(redirect);
      }

      setQueryParamsProcessed(true);
    }
  }, [openplayer, redirect, router.isReady]);
  (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(function () {
    if (queryParamsProcessed) {
      router.replace({
        pathname: router.pathname,
        query: rest
      }, undefined, {
        scroll: false
      });

      if (session !== null && session !== void 0 && session.user) {
        onSuccess(!!openplayer, redirect);
      }
    }
  }, [queryParamsProcessed]);
  var t = (0,app_hooks_lang__WEBPACK_IMPORTED_MODULE_13__/* .useTranslate */ .q)();
  (0,app_hooks_go_back_hook__WEBPACK_IMPORTED_MODULE_3__/* .useGoBackHistory */ .J)("LOGIN");
  var getMetaDescription = (0,app_utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();

  var onSuccess = function onSuccess(openPlayer, redirect) {
    if (openPlayer) {
      setFullscreenPlayerInitialyOpen(true);
    }

    if (redirect) {
      var targetSplit = redirect.split("?");

      if (targetSplit.length > 1) {
        router.push({
          pathname: targetSplit[0],
          query: _objectSpread({}, qs__WEBPACK_IMPORTED_MODULE_9___default().parse(targetSplit[1]))
        });
      } else {
        router.push(redirect);
      }
    } else {
      var _window, _window$history;

      if ( true && ((_window = window) === null || _window === void 0 ? void 0 : (_window$history = _window.history) === null || _window$history === void 0 ? void 0 : _window$history.length) <= 2) {
        // 2 beacuse of language redirect
        router.push('/');
      } else {
        router.back();
      }
    }
  };

  var onSuccessCallback = (0,react__WEBPACK_IMPORTED_MODULE_10__.useCallback)(function () {
    onSuccess(openPlayerAfterLogin, redirectTo);
  }, [openPlayerAfterLogin, redirectTo]);
  var onCloseCallback = (0,react__WEBPACK_IMPORTED_MODULE_10__.useCallback)(function () {
    router.back();

    if (openPlayerAfterLogin) {
      setFullscreenPlayerInitialyOpen(true);
    }
  }, [openPlayerAfterLogin]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
      className: (_log_in_module_scss__WEBPACK_IMPORTED_MODULE_14___default().container),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_7___default()), {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("title", {
          children: [t("log-in"), " - Radioline"]
        }), getMetaDescription(t("settings.meta-description"))]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(app_components_auth_auth_component__WEBPACK_IMPORTED_MODULE_1__/* .Auth */ .g, {
        onClose: onCloseCallback,
        onSuccess: onSuccessCallback
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (LogIn);

/***/ }),

/***/ 27267:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/log-in",
      function () {
        return __webpack_require__(84563);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45550:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","container":"log-in_container__y3sEz"};

/***/ }),

/***/ 43337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useInterval = function (callback, delay) {
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () { });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        savedCallback.current = callback;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (delay !== null) {
            var interval_1 = setInterval(function () { return savedCallback.current(); }, delay || 0);
            return function () { return clearInterval(interval_1); };
        }
        return undefined;
    }, [delay]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useInterval);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9273,5052,9774,2888,179], function() { return __webpack_exec__(27267); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);